import React, {useContext, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {DispatchContext} from '../../../store';
import {catalogueApi} from '../../../services/CatalogueServices';
import {SNACKBAR_OPEN} from '../../../reducers';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SearchComponent from '../../../common/SearchComponent/SearchComponent';
import {Form, Formik} from 'formik';
import {Button, Card, Grid} from '@mui/material';
import {transfersApi} from '../../../services/TransferServices';
import TransferEntryOne from './TransferEntryOne';
import TransferEntryTwo from './TransferEntryTwo';
import TransferEntryThree from './TransferEntryThree';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

export default function AddTransferCatalog(props) {
  const navigate = useNavigate();
  const dispatch = useContext(DispatchContext);
  const [transfers, setTransfers] = useState([]);
  const [searched, setSearched] = useState(false);
  const availableData = transfers?.[0];
  const code = 'en';

  const handleSearch = (searchAccession) => {
    if (searchAccession.trim() !== '') {
      catalogueApi('get', null, {search: searchAccession}).then(res => {
        setTransfers({
          ...res?.data,
        });
      })
    }
  }

  const handleClear = () => {
    setTransfers([]);
  }

  const getStringValue = (value) => {
    if (!value) return '';
    if (typeof value === 'object') {
      return value?.name || value?.code || '';
    }
    return value;
  };

  const onSubmit = (values) => {
    const payload = {
      recipient_museum_id: values?.recipient_museum_id,
      sender_museum_id: values?.museum_id,
      accession_no: getStringValue(values?.accession_no),
      catalogue_id: values?.id,
      attachment_ids: values?.attachments?.map(val => val?.id) || [],
      translations: {
        en: {
          remarks: values?.remarks,
        }
      }
    }

    transfersApi('post', payload).then(res => {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Transfers artefact created successfully'}
      });
      setSearched(false);
      navigate('/management/artifact-managements')
    }).catch(() => {})
  }

  return (
    <PageWrapper>
      <Box sx={{display: {sm: 'flex', xs: 'column'}, alignItems: 'center', mt: 7, mb: 2}}>
        <Typography className={'text-500 font30'} sx={{color: '#757575'}}>Transfer Request</Typography>
        <Box sx={{ml: {sm: 5, xs: 0}}}>
          <SearchComponent onSearch={handleSearch} searched={searched} setSearched={setSearched}
                           onClear={handleClear} placeholder={'Enter accession number'}/>
        </Box>
      </Box>
      <Box className={'header-divider'}/>
      <Formik initialValues={availableData}
              onSubmit={onSubmit}
              validateOnBlur={true} enableReinitialize
      >
        {({isSubmitting, touched, errors, values, setFieldValue, ...formik}) => (
          <Form>
            {searched &&
            <Box sx={{mb: {sm: 4, xs: 2}}}>
              <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                  <TransferEntryOne code={code}/>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <TransferEntryTwo code={code}/>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <TransferEntryThree code={code}/>
                </Grid>
              </Grid>
              <Box className={'dotted-divider'}/>
              <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                  <Card className={'box-shadow'} sx={{p: 2}}>
                    <Typography sx={{mb: 1}}>Catalogue Picture(s)</Typography>
                    <Box className={'flex'}>
                      {availableData?.attachments?.length > 0 && availableData?.attachments?.map((val, index) => (
                        <img key={index} src={val?.file} style={{width: 60, height: 60, marginRight: 5}}
                             alt="catalog_image"/>
                      ))}
                    </Box>
                  </Card>
                </Grid>
              </Grid>
              <Box>
                <Grid container spacing={2}>
                  <Grid item sm={9} xs={12}/>
                  <Grid item sm={3} xs={12}>
                    <Grid container spacing={2}>
                      <Grid item sm={6} xs={12}>
                        <Button onClick={() => navigate(-1)} variant={'outlined'} color={'error'}
                                fullWidth>Cancel</Button>
                      </Grid>
                      <Grid item sm={6} xs={12}>
                        <Button variant={'contained'} type={'submit'} fullWidth>Submit</Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Box>
            }
          </Form>
        )}
      </Formik>
    </PageWrapper>
  );
}